import { useRootStore } from '~/store/root'

export default defineNuxtRouteMiddleware(() => {
  useRootStore().$patch({ isCypressUser: window.navigator.userAgent === 'lendioCypressTestUser' })
});
